import { useMemo, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "../config/api";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => String(searchParams.get("token") || "").trim(), [searchParams]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const API_URL = API_BASE_URL;

  async function handleSubmit(event) {
    event.preventDefault();
    if (loading) return;

    setError("");
    setSuccess("");

    if (!token) {
      setError("Resetlink is ongeldig of onvolledig.");
      return;
    }

    if (!newPassword || !confirmPassword) {
      setError("Vul beide wachtwoordvelden in.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Wachtwoorden zijn niet gelijk.");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}/api/auth/reset-password`, {
        token,
        newPassword,
        confirmPassword,
      });
      setSuccess(res?.data?.message || "Wachtwoord is succesvol aangepast.");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err?.response?.data?.message || "Wachtwoord resetten mislukt.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-[100dvh] bg-[#f3f4f6] px-4 py-8">
      <div className="mx-auto w-full max-w-xl rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
        <h1 className="mb-3 text-3xl font-semibold tracking-tight text-slate-900">
          Nieuw wachtwoord instellen
        </h1>
        <p className="mb-6 text-sm text-slate-600">
          Kies een nieuw wachtwoord om je account weer te gebruiken.
        </p>

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Nieuw wachtwoord"
            className="h-12 w-full rounded-xl border border-slate-200 bg-[#f5f4dd] px-4 text-slate-800 outline-none transition focus:border-blue-400 focus:bg-white"
            autoComplete="new-password"
            required
          />
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Herhaal wachtwoord"
            className="h-12 w-full rounded-xl border border-slate-200 bg-[#f5f4dd] px-4 text-slate-800 outline-none transition focus:border-blue-400 focus:bg-white"
            autoComplete="new-password"
            required
          />
          <button
            type="submit"
            disabled={loading || !token}
            className="h-12 w-full rounded-xl bg-[#77aee4] text-base font-semibold text-white transition hover:bg-[#679fd8] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? "Opslaan..." : "Nieuw wachtwoord opslaan"}
          </button>
        </form>

        {error ? (
          <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            {error}
          </div>
        ) : null}

        {success ? (
          <div className="mt-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
            {success}
          </div>
        ) : null}

        <div className="mt-6 text-sm">
          <Link to="/login" className="text-slate-600 underline hover:text-slate-900">
            Terug naar login
          </Link>
        </div>
      </div>
    </div>
  );
}
